
export enum HssRegionCd {
	HSSLN = 'HSSLN',
	HSSU = 'HSSU',
	HSSX = 'HSSX'}
